var url = "https://api.finodo.com/api/v1/";
var obUrl = "https://app.finodo.com/";
var env = process.env.NODE_ENV;

if (window.location.href.includes("-staging-")) env = "staging";

if (env == "development") {
  url = "https://finodo-backend-staging-2ki22i6pja-ew.a.run.app/api/v1/";
  obUrl =
    "https://finodo-frontend-staging-1052548071181.europe-west3.run.app";
}
if (env == "staging") {
  url = "https://finodo-backend-staging-2ki22i6pja-ew.a.run.app/api/v1/";
  obUrl =
    "https://finodo-frontend-staging-1052548071181.europe-west3.run.app";
}

const environment = {
  environment: env,
  gitHash: undefined,
  baseUrl: url,
  onboardingUrl: obUrl,
};

//console.log(environment);

export const Environment = environment;
